import styled from "styled-components";

export const SubmitButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 160px;
  height: 42px;
  background: transparent;
  border: 4px solid #dcdcdc;
  font-size: 24px;
  color: #111;
  transition: background-color 0.2s linear;
  transition: box-shadow 0.2s linear;
  &:hover {
    background-color: #dcdcdc;
    color: #111;
  }
  &:active {
    box-shadow: inset 0px 5px 10px -5px rgba(0, 0, 0, 0.8);
  }
`;
export default SubmitButton;
